<template>
<section class="concept-section _preview-section" v-if="$store.state.register.form.other_brand">

    <div class="section-inner">
        <div class="concept-item">
            <h2 class="heading-section">その他の取扱いブランド</h2>
            <p>{{ $store.state.register.form.other_brand }}</p>
        </div>
    </div>

</section><!--/.page-name-row-->
</template>
